import { render } from "./TipTapTextArea.vue?vue&type=template&id=31a9ae04&scoped=true"
import script from "./TipTapTextArea.vue?vue&type=script&lang=ts"
export * from "./TipTapTextArea.vue?vue&type=script&lang=ts"

import "./TipTapTextArea.vue?vue&type=style&index=0&id=31a9ae04&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31a9ae04"

export default script